import React from 'react';
import { Link, IndexLink } from 'react-router';
import cx from 'classnames';
import { appContext } from '../../util/decorators';
import FollowButton from 'component/Page/FollowButton';
import FeedbackWidget from 'component/Feedback/FeedbackWidget';
import Footer from 'component/Sidebar/Footer';

@appContext
export default class MobileNav extends React.PureComponent {
  setLink(isLinkExternal, link) {
    if (isLinkExternal) {
      return <a href={link.url} className="navbar-link" target={'_blank'}>{link.name}</a>;
    }

    return <Link className="navbar-link" to={link.url} activeClassName="active">{link.name}</Link>;
  }

  getListItem(link, className) {
    const isLinkExternal = link.url.indexOf('http') === 0;
    const target = isLinkExternal ? '_blank' : '';

    return (
      <li key={link.url} className={className}>
        {
          link.url === '/' ?
            <IndexLink target={target} className="navbar-link" to={link.url} activeClassName="active">{link.name}</IndexLink>
          :
            this.setLink(isLinkExternal, link)
        }
      </li>
    );
  }

  render() {
    return (
      <div className={cx('nav-mobile', { 'is-visible': this.props.visible })}>
        <ul>
          {
            this.props.menuLinks.mainMenuLinks && this.props.menuLinks.mainMenuLinks.length > 0 &&
              this.props.menuLinks.mainMenuLinks.map((link) => {
                return this.getListItem(link, 'primary');
              })
          }
          {
            this.props.menuLinks.secondaryMenuLinks && this.props.menuLinks.secondaryMenuLinks.length > 0 &&
              this.props.menuLinks.secondaryMenuLinks.map((link) => {
                return this.getListItem(link, 'secondary');
              })
          }
        </ul>

        <Footer />

      </div>
    );
  }
}

const menuLinks = React.PropTypes.arrayOf(React.PropTypes.shape({
  id: React.PropTypes.number,
  url: React.PropTypes.string,
  name: React.PropTypes.string,
}));

MobileNav.propTypes = {
  menuLinks: React.PropTypes.shape({
    mainMenuLinks: menuLinks,
    secondaryMenuLinks: menuLinks,
  }),
  visible: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/component/Navigation/MobileNav.jsx